import { scroller } from './smoothScroll';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import { SplitText } from 'gsap/SplitText';
import { head } from 'underscore';

gsap.registerPlugin(SplitText);

export default (els) => {
	Array.prototype.forEach.call(els, (el) => {

		let headline = el.querySelector('.hero__headline > div > h1');
		let subhead = el.querySelector('.hero__subhead > p');
		let accent = el.querySelector('.hero--accent');
		let heroLink = el.querySelector('.hero--link');
		//let header = document.querySelector('header');

		gsap.set(accent, {
			transformOrigin: 'center top',
		});

		gsap.set(heroLink, {
			yPercent: 100,
		});

		// gsap.set(header, {
		//     yPercent: -100
		// });

		let splitHeadline = new SplitText(headline, {
			type: 'words, lines',
			position: 'absolute',
			linesClass: 'lines',
		});

		let splitSubhead = new SplitText(subhead, {
			type: 'words, lines',
			position: 'relative',
			linesClass: 'lines',
		});

		let timeline = gsap.timeline({
			paused: true, delay: 1, onComplete: () => {

			}
		});

		timeline.from(
			accent,
			{
				duration: 2,
				scale: 0,
				ease: Expo.easeInOut,
			},
			0
		);

		timeline.from(
			splitHeadline.lines,
			{
				duration: 3,
				xPercent: -100,
				stagger: 0.15,
				ease: Power4.easeOut,
			},
			'<+=1'
		);

		timeline.from(
			splitSubhead.words,
			{
				duration: 1.5,
				yPercent: 100,
				stagger: 0.03,
				ease: Power4.easeOut,
			},
			'<+=0.75'
		);

		timeline.to(
			heroLink,
			{
				duration: 1,
				yPercent: 0,
				ease: Expo.easeIn,
			},
			'<+=1'
		);

		timeline.play();

		// let linkTl = gsap.timeline({
		// 	scrollTrigger: {
		// 		trigger: heroLink,
		// 		start: 'top 50%',
		// 		end: 'top 20%',
		// 		scrub: 1,
		// 		markers: true,
		// 	},
		// 	paused: true
		// });

		// linkTl.to(heroLink, {
		// 	yPercent: 100,
		// 	duration: 1,
		// 	ease: Expo.easeOut
		// });


	});
};
